import { createRouter, createWebHashHistory } from 'vue-router'
import Bots from '../views/Bots.vue'
import AddBot from '../views/AddBot.vue'
import Sender from '../views/Sender.vue'
import BroadcastStatus from "@/views/BroadcastStatus.vue";
import Projects from "@/views/Projects.vue";

const routes = [
    {
        path: '/',
        name: 'bots',
        component: Bots,
    },
    {
        path: '/sender',
        name: 'sender',
        component: Sender,
    },
    {
        path: '/add-bot',
        name: 'addbot',
        component: AddBot,
    },
    {
        path: '/broadcast_status',
        name: 'broadcaststatus',
        component: BroadcastStatus,
    },
    {
        path: '/projects',
        name: 'projects',
        component: Projects,
    },
]

const router = createRouter({
    history: createWebHashHistory(),
    routes,
})

export default router
